import { SectionHeader } from '@apps/components/section-header';
import React from 'react';

const Features = ({title, subTitle, featuresContent, image = "/images/process.png", animationImage}) => {
  return (
    <>
      {/* <!-- Features --> */}
      <section className="container relative pt-24 pb-10 dark:bg-jacarta-800">
        {title && (
          <SectionHeader title={title} subTitle={subTitle}/>
        )}
        <div className="container">
          <div className="lg:items-center lg:flex lg:flex-nowrap">
            <div className="mb-16 lg:w-1/2 lg:pr-20">
              <figure className="flex items-center justify-center">
                <img
                  src={image}
                  alt="features"
                  loading="lazy"
                  className="rounded-2.5xl mx-auto"
                />
                {animationImage && (
                  <img
                    src={animationImage}
                    alt=""
                    className="absolute animate-spin-slow"
                  />
                )}

              </figure>
            </div>
            {/* <!-- End Left Image --> */}

            {/* <!-- Info --> */}
            <div className="mb-16 lg:w-1/2 lg:pl-5">
              {featuresContent?.title && (
                <h2 className="mb-6 font-display text-2xl text-jacarta-700 dark:text-white">
                  {featuresContent?.title}
                </h2>
              )}
              {featuresContent?.subTitle && (
                <p className="mb-8 text-lg leading-normal dark:text-jacarta-300">
                  {featuresContent.subTitle}
                </p>
              )}
              {featuresContent?.data?.map((item) => (
                <div className="mb-6 flex space-x-6" key={item.id}>
                  <div className="inline-flex h-[68px] w-[68px] shrink-0 items-center justify-center rounded-full bg-white shadow-2xl dark:bg-jacarta-700">
                    {item.icon}
                  </div>
                  <div>
                    <h3 className="mb-3 mt-2 block font-display text-xl font-semibold text-jacarta-700 dark:text-white">
                      {item.title}
                    </h3>
                    <p className="dark:text-jacarta-300">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* <!-- end features -->   */}
    </>
  );
};

export default Features;
